module.exports = __webpack_public_path__ + "media/images/salary-submitted-f9f387f8069ee6b4caa0466498f26997.svg";